module.exports = __webpack_public_path__ + "img/shop-icon.4b86b6af.svg";